module.exports = __webpack_public_path__ + "media/country_flags/kr-7daec510.png";